import {Injectable} from '@angular/core';
import {StageService} from '../stage.service';
import {LightMapGenerator} from './LightMapGenerator';
import {Box} from './Box';
import {ILightFlags} from './types';
import {FloorUVGenerator, StairsUVGenerator} from './uvGenerator';

declare const THREE: any;

@Injectable()
export class RailingLightmapService {

  private floorUVGen = new FloorUVGenerator();
  private stairsUVGen = new StairsUVGenerator();
  private lightMapGenerator = new LightMapGenerator(false);

  constructor(
    private stage: StageService
  ) {
  }

  forAll(flags: ILightFlags) {

    const atLeastOneChecked = flags.top || flags.bottom || flags.post;

    const floorContainer = this.stage.getCompoundFloor();
    floorContainer.updateMatrixWorld();

    const box = new Box(floorContainer);
    const scene = this.stage.scene;

    let texture;

    if (atLeastOneChecked) {
      const canvas = this.lightMapGenerator.generate(scene, box, flags);
      texture = new THREE.Texture(canvas);
    } else {
      texture = null;
    }

    scene.traverse(obj => {

      if (obj.name === 'floor') {
        const geometry = obj.geometry;
        geometry.faceVertexUvs[1] = this.floorUVGen.generate(box, obj);
        geometry.elementsNeedUpdate = true;
        geometry.uvsNeedUpdate = true;
        const material = obj.material[0];
        material.lightMap = texture;
        material.lightMapIntensity = 3;
        if (texture) {
          material.lightMap.needsUpdate = true;
        }
        material.needsUpdate = true;
      }

      if (obj.name === 'Steps') {
        const uvs = this.stairsUVGen.generate(box, obj);
        obj.geometry = obj.geometry.clone();
        const geometry = obj.geometry;
        geometry.addAttribute('uv2', new THREE.BufferAttribute(uvs, 2));
        geometry.attributes.uv2.needsUpdate = true;
        const material = obj.material;
        material.lightMap = texture;
        material.lightMapIntensity = 3;
        if (texture) {
          material.lightMap.needsUpdate = true;
        }
        material.needsUpdate = true;
      }

    });

  }

}



// WEBPACK FOOTER //
// ./src/app/services/lightMap/railing-lightmap.service.ts